<table class="forecast-table">
  <thead>
    <tr>
      <th>{{ 'forecast.card.table.sizes' | translate }}</th>
      @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
        <th>
          <div class="month-header">
            <span>{{ 'common.months.' + monthNumber | translate }}</span>
            <span class="year">{{ getYearForMonth(monthNumber) }}</span>
          </div>
        </th>
      }
      <th>{{ 'forecast.card.table.action' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @if (this.pendingRepPlan) {
      <!-- TOTAL ROW -->
      <ng-container>
        <tr (click)="toggleExpand(pendingRepPlan?.totalLine)" class="expandable-row">
          <td colspan="14">
            <div class="expandable-row-title-cell title-row-total">
              @if(pendingRepPlan?.totalLine?.expanded === 'expanded') {
                <mat-icon class="expand-icon">expand_more</mat-icon>
              } @else {
                <mat-icon class="expand-icon">chevron_right</mat-icon>
              }
              {{ 'forecast.card.table.total' | translate }}
            </div>
          </td>
        </tr>
        <!-- Total fitment -->
        <tr class="detail-row" [class.expanded]="pendingRepPlan?.totalLine?.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="pendingRepPlan?.totalLine?.expanded">
            <td class="detail-row-td rep-title">{{ 'forecast.card.table.totalFitment' | translate }}</td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td">
              <div class="detail-row-cell-content"
                   [@expandTrigger]="pendingRepPlan?.totalLine?.expanded">
                <span class="rep-number">{{ pendingRepPlan?.totalLine?.columns[monthNumber].totalFitment }}</span>
              </div>
            </td>
          }
        </tr>
        <!-- Total stock quantity (end of month) -->
        <tr class="detail-row" [class.expanded]="pendingRepPlan?.totalLine?.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="pendingRepPlan?.totalLine?.expanded">
            <td class="detail-row-td rep-title">
              <span>{{ 'forecast.card.table.totalStock' | translate }}</span>
              <span class="rep-param">
          Min: {{ getTotalStockMin() }} Max: {{ getTotalStockMax() }}
        </span>
            </td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td">
              <div class="detail-row-cell-content"
                   [@expandTrigger]="pendingRepPlan?.totalLine?.expanded">
          <span class="rep-number"
                [ngClass]="getTotalStockColor(pendingRepPlan?.totalLine?.columns[monthNumber].totalStock)">
            {{ pendingRepPlan?.totalLine?.columns[monthNumber].totalStock }}
          </span>
              </div>
            </td>
          }
        </tr>
        <!-- Average coverage (Month) -->
        <tr class="detail-row" [class.expanded]="pendingRepPlan?.totalLine?.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="pendingRepPlan?.totalLine?.expanded">
            <td class="detail-row-td rep-title">
              <span>{{ 'forecast.card.table.averageCoverageMonth' | translate }}</span>
              <span class="rep-param">Target: {{ this.pendingRepPlan.param.targetCoverage }}</span>
            </td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td">
              @if (pendingRepPlan?.totalLine?.columns[monthNumber].averageCoverageMonth >= Number.POSITIVE_INFINITY) {
                @if (isTotalExpanded()) {
                  <span class="rep-number">
                  <mat-icon class="rep-number">
                    all_inclusive
                  </mat-icon>
                </span>
                }
              } @else {
                <div class="detail-row-cell-content"
                     [@expandTrigger]="pendingRepPlan?.totalLine?.expanded">
                  <span class="rep-number" [ngClass]="getCoverageColorFollowParam(pendingRepPlan?.totalLine?.columns[monthNumber].averageCoverageMonth)">
                    {{ pendingRepPlan?.totalLine?.columns[monthNumber].averageCoverageMonth | number:'1.1-1' }}
                  </span>
                </div>
              }
            </td>
          }
        </tr>
        <!-- Total replenishment -->
        <tr class="detail-row" [class.expanded]="pendingRepPlan?.totalLine?.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="pendingRepPlan?.totalLine?.expanded">
            <td class="detail-row-td rep-title">{{ 'forecast.card.table.totalReplenishment' | translate }}</td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td">
              <div class="detail-row-cell-content"
                   [@expandTrigger]="pendingRepPlan?.totalLine?.expanded">
                <span class="rep-number">{{ pendingRepPlan?.totalLine?.columns[monthNumber].totalReplenishment }}</span>
              </div>
            </td>
          }
        </tr>
      </ng-container>
      <!-- SPEC ROWS -->
      @for (row of pendingRepPlan?.replPlanSpecLines; track row.tireSpecPk) {
        <tr (click)="toggleExpand(row)" class="expandable-row">
          <td colspan="14">
            <div class="expandable-row-title-cell">
              @if(row.expanded === 'expanded') {
                <mat-icon class="expand-icon">expand_more</mat-icon>
              } @else {
                <mat-icon class="expand-icon">chevron_right</mat-icon>
              }
              {{ row.specificationFull }}
            </div>
          </td>
        </tr>
        <!-- Stock (end of month) -->
        <tr class="detail-row" [class.expanded]="row.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="row.expanded">
            <td class="detail-row-td rep-title">
              <span>{{ 'forecast.card.table.stockEndMonth' | translate }}</span>
              <span class="rep-param">Min: {{ this.pendingRepPlan.param.stockMin }} Max: {{ this.pendingRepPlan.param.stockMax }}</span>
            </td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td">
              <div class="detail-row-cell-content"
                   [@expandTrigger]="row.expanded">
                <span class="rep-number" [ngClass]="getStockColorFollowParam(row.columns[monthNumber].stockQty)">
                  {{ row.columns[monthNumber].stockQty }}
                </span>
              </div>
            </td>
          }
        </tr>
        <!-- Coverage (Month) -->
        <tr class="detail-row" [class.expanded]="row.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="row.expanded">
            <td class="detail-row-td rep-title">
              <span>{{ 'forecast.card.table.coverageMonth' | translate }}</span>
              <span class="rep-param">Target: {{ this.pendingRepPlan.param.targetCoverage }}</span>
            </td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td">
              <div class="detail-row-cell-content"
                   [@expandTrigger]="row.expanded">
                  @if (row.columns[monthNumber].coverageMonth >= Number.POSITIVE_INFINITY) {
                    <span class="rep-number">
                      <mat-icon class="rep-number">
                        all_inclusive
                      </mat-icon>
                    </span>
                  } @else {
                    <span class="rep-number" [ngClass]="getCoverageColorFollowParam(row.columns[monthNumber].coverageMonth)">
                      {{ row.columns[monthNumber].coverageMonth | number:'1.1-1' }}
                    </span>
                  }
              </div>
            </td>
          }
        </tr>
        <!-- Fitment forecast -->
        <tr class="detail-row" [class.expanded]="row.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="row.expanded">
            <td class="detail-row-td rep-title">{{ 'forecast.card.table.fitmentForecast' | translate }}</td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td">
              <div class="detail-row-cell-content"
                   [@expandTrigger]="row.expanded">
                <span class="rep-number">{{ row.columns[monthNumber].fitmentForecast }}</span>
              </div>
            </td>
          }
          <div class="detail-row-cell-content action-cell"
               [@expandTrigger]="row.expanded">
            <td class="detail-row-td">
              <button
                class="button-redo"
                mat-icon-button
                color="blue"
                (click)="copyOneSpecFitmentsAndRecalculate(row)"
                [matTooltip]="'forecast.card.table.actions.copyFitment' | translate"
                matTooltipPosition="above">
                <mat-icon class="icon-redo icon-color">
                  redo
                </mat-icon>
              </button>
            </td>
          </div>
        </tr>
        <!-- Confirmed fitment -->
        <tr class="detail-row" [class.expanded]="row.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="row.expanded">
            <td class="detail-row-td rep-title">{{ 'forecast.card.table.confirmedFitment' | translate }}</td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td">
              <div class="detail-row-cell-content"
                   [@expandTrigger]="row.expanded">
                @if (isInPast(row.columns[monthNumber])) {
                  <span class="rep-number">{{ row.columns[monthNumber].confirmedFitment }}</span>
                } @else {
                  <div class="input-edited-wrapper">
                    @if (isModified(row.columns[monthNumber].confirmedFitment ?? 0, row.columns[monthNumber].fitmentForecast ?? 0)) {
                      <span class="input-edited-marker"></span>
                    }
                    <input matInput
                           type="text"
                           maxlength="3"
                           inputmode="numeric"
                           pattern="\d*"
                           class="tkc-input"
                           nxNoScroll
                           [mask]="digitMask"
                           [patterns]="digitPatterns"
                           [dropSpecialCharacters]="true"
                           (change)="onChange(row, monthNumber, 'confirmedFitment')"
                           [ngClass]="{'ng-invalid': getControl(row, monthNumber, 'confirmedFitment').invalid}"
                           [formControl]="getControl(row, monthNumber, 'confirmedFitment')" />
                  </div>
                }
              </div>
            </td>
          }
        </tr>
        <!-- Proposed replenishment -->
        <tr class="detail-row" [class.expanded]="row.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="row.expanded">
            <td class="detail-row-td rep-title">{{ 'forecast.card.table.proposedRepl' | translate }}</td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td" [ngClass]="(row.columns[monthNumber].frozen ? 'frozen-zone' : '')">
              <div class="detail-row-cell-content"
                   [@expandTrigger]="row.expanded">
                <span class="rep-number">{{ row.columns[monthNumber].proposedRepl }}</span>
              </div>
            </td>
          }
          <div class="detail-row-cell-content action-cell"
               [@expandTrigger]="row.expanded">
            <td class="detail-row-td">
              <button
                class="button-redo"
                mat-icon-button
                color="blue"
                (click)="copyOneSpecProposedReplAndRecalculate(row.tireSpecPk)"
                [matTooltip]="'forecast.card.table.actions.copyReplenishment' | translate"
                matTooltipPosition="above">
                <mat-icon class="icon-redo icon-color">
                  redo
                </mat-icon>
              </button>
            </td>
          </div>
        </tr>
        <!-- Confirmed replenishment -->
        <tr class="detail-row" [class.expanded]="row.expanded === 'expanded'">
          <div class="detail-row-cell-content"
               [@expandTrigger]="row.expanded">
            <td class="detail-row-td rep-title">{{ 'forecast.card.table.confirmedRepl' | translate }}</td>
          </div>
          @for (monthNumber of monthsNumbersToDisplay; track monthNumber;) {
            <td class="detail-row-td" [ngClass]="(row.columns[monthNumber].frozen ? 'frozen-zone' : '')">
              <div class="detail-row-cell-content"
                   [@expandTrigger]="row.expanded">
                @if (row.columns[monthNumber].frozen || isInPast(row.columns[monthNumber])) {
                  <span class="rep-number">{{ row.columns[monthNumber].confirmedRepl }}</span>
                } @else {
                  <div class="input-edited-wrapper">
                    @if (isModified(row.columns[monthNumber].confirmedRepl ?? 0, row.columns[monthNumber].proposedRepl ?? 0)) {
                      <span class="input-edited-marker"></span>
                    }
                    <input matInput
                           type="text"
                           maxlength="3"
                           inputmode="numeric"
                           pattern="\d*"
                           class="tkc-input"
                           nxNoScroll
                           [mask]="digitMask"
                           [patterns]="digitPatterns"
                           [dropSpecialCharacters]="true"
                           (change)="onChange(row, monthNumber, 'confirmedRepl')"
                           [ngClass]="{'ng-invalid': getControl(row, monthNumber, 'confirmedRepl').invalid}"
                           [formControl]="getControl(row, monthNumber, 'confirmedRepl')" />
                  </div>
                }
              </div>
            </td>
          }
        </tr>
      }
    } @else {
      <tr>
        <td colspan="14" class="expandable-row">
          <div id="no-data-for-size-and-year">
            <span>{{ 'forecast.card.table.noDataForSizeAndYear1' | translate }}</span>
            <span>{{ 'forecast.card.table.noDataForSizeAndYear2' | translate }}</span>
          </div>
        </td>
      </tr>
    }
  </tbody>
</table>
